import type { ChangeEvent, ReactNode } from 'react'

import { useRouter } from 'next/router'
import { useT } from '@/lib/i18n'
import { cn } from '@/lib/utils'
import { useShop } from '@/components/providers/shop-provider'
import { CURRENCIES, localeNames, locales } from '@/constants/shop'

const selectClass = 'h-10 cursor-pointer rounded-full border-2 border-line bg-card px-3 text-sm font-semibold text-foreground focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-grape/40'

interface SwitchersProps {
    className?: string
}

export const Switchers = ({ className }: SwitchersProps): ReactNode => {
    const router = useRouter()
    const t = useT()
    const { currency, setCurrency } = useShop()

    const changeLocale = (event: ChangeEvent<HTMLSelectElement>) => {
        router.push({ pathname: router.pathname, query: router.query }, router.asPath, { locale: event.target.value, scroll: false })
    }

    return (
        <div className={cn('flex items-center gap-2', className)}>
            <label className='sr-only' htmlFor='language-switch'>
                {t('language')}
            </label>

            <select id='language-switch' value={router.locale ?? 'en'} onChange={changeLocale} className={selectClass}>
                {locales.map(code => (
                    <option key={code} value={code}>
                        {localeNames[code]}
                    </option>
                ))}
            </select>

            <label className='sr-only' htmlFor='currency-switch'>
                {t('currency')}
            </label>

            <select id='currency-switch' value={currency} onChange={event => setCurrency(event.target.value)} className={selectClass}>
                {CURRENCIES.map(code => (
                    <option key={code} value={code}>
                        {code}
                    </option>
                ))}
            </select>
        </div>
    )
}
